<template>
  <div class="errorToast">
    <div id="wx_reg"></div>
  </div>
</template>

<script>
import utils from "@/utils";

export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    wxLogin() {
      let redirect_uri = encodeURIComponent("https://portal.longtubas.com/#/");
      if(utils.getSearchParams("ssoappid") != null) {
        redirect_uri = encodeURIComponent("https://portal.longtubas.com/vpn_redirect?ssoappid=" + utils.getSearchParams("ssoappid") + "&url=" + encodeURIComponent(utils.getSearchParams("jump_url2")) + "#/");
      }
      window.WwLogin({
        id: "wx_reg",
        appid: "wwf52dc03299bc0260",
        agentid: "1000008",
        redirect_uri: redirect_uri,
        state: "qr_state",
        href: ""
      });
    }
  },
  created() {
    this.wxLogin();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.errorToast {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: #edf1f5;
  z-index: 10000001;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
